<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import CalendarEventChip from 'dashboard/components-next/Calendar/CalendarEventChip.vue';

const props = defineProps({
  currentDate: { type: Date, required: true },
  eventsForDay: { type: Function, required: true },
});

defineEmits(['reschedule', 'complete']);

const { t } = useI18n();

const dayEvents = computed(() =>
  [...props.eventsForDay(props.currentDate)].sort((a, b) => a.date - b.date)
);
</script>

<template>
  <div
    class="flex flex-col flex-1 min-h-0 overflow-hidden border rounded-lg border-n-weak"
  >
    <div class="flex flex-col flex-1 min-h-0 gap-1 p-3 overflow-y-auto">
      <CalendarEventChip
        v-for="event in dayEvents"
        :key="event.contact.id"
        :event="event"
        @reschedule="$emit('reschedule', $event)"
        @complete="$emit('complete', $event)"
      />
      <div
        v-if="!dayEvents.length"
        class="flex items-center justify-center flex-1 text-sm text-n-slate-9"
      >
        {{ t('CALENDAR.NO_EVENTS') }}
      </div>
    </div>
  </div>
</template>
